import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// --- ARGUSAUTOMOBILE.TN CONSOLE WELCOME ---
if (import.meta.env.MODE === 'production') {
  const carArt = [
    '                       _____________________',
    '    /  .       .      (<$$$$$$>#####<::::::>)',
    '   .      .     .  _/~~~~~~~~~~~~~~~~~~~~~~~~~\\_   .       .   .   \\',
    '.(          . .  /~                             ~\\ . .   .',
    '  ( . .        .~                                 ~.      .         )',
    '           ()\\/_____                           _____\\/()   .    .  ).',
    '(         .-\'\'      ~~~~~~~~~~~~~~~~~~~~~~~~~~~     ``-.  ...',
    '.  . . .-~              __________________              ~-.  .    /',
    ' .   ..\\`~~/~~~~~~~~~~~~TTTTTTTTTTTTTTTTTTTT~~~~~~~~~~~~\\~~\'    . ) .',
    '    . .| | | #### #### || | | | [] | | | || #### #### | | | .',
    '   (   ;__\\\\|___________|++++++++++++++++++|___________|/__;.   .',
    '     .  (~~====___________________________________====~~~)',
    ' ( .  .. \\------_____________[ ARGUS ]__________-------/ ..  .     )',
    '         .  |      ||         ~~~~~~~~       ||      |',
    '             \\_____/                          \\_____/',
  ].join('\n');

  const artStyle = [
    'font-family: monospace',
    'color: #D5462E', // Brand red
    'font-weight: bold',
    'font-size: 12px',
  ].join(';');

  const titleStyle = [
    'font-size: 24px',
    'font-weight: bold',
    'color: #D5462E',
    'font-family: sans-serif',
    'text-shadow: 2px 2px 4px rgba(0,0,0,0.1)',
  ].join(';');

  const textStyle = [
    'font-size: 14px',
    'font-family: sans-serif',
    'color: #222',
  ].join(';');

  const linkStyle = [
    'font-size: 14px',
    'font-family: sans-serif',
    'color: #007bff',
  ].join(';');

  console.log(`%c${carArt}`, artStyle);
  console.log('%cBienvenue sur ArgusAutomobile.TN!', titleStyle);
  console.log('%cVous avez trouvé un bug ou une faille de sécurité? 🕵️‍♂️', textStyle);
  console.log('%cSoyez constructifs, contactez-nous! ❤️', textStyle);
  console.log('%c📧 https://www.argusautomobile.tn/contact', linkStyle);
}
// --- END OF CONSOLE WELCOME ---

// --- React App Entry Point ---
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
